<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>

          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Movimientos de carga de entrada y salida. 
                Lista y procesa cargas que van hacia rutas 
                u oficinas (Out) y las que regresan (In). 
                Úsalo para confirmar qué salió, qué volvió y 
                cuadrar inventario.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Cargas In/Out
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Lista, procesa y sincroniza <b>cargas In/Out</b> destinada a los <b>socios de negocio</b> de forma individual
          y/o bloque.
        </div>
      </div>
      <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Listado de Cotizaciones</div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses" [selectedERPStatuses]="selectedERPStatuses"
            [selectedCustomerType]="selectedCustomerType" [showStatus]="[StatusEnum.ACTIVE, StatusEnum.INACTIVE, StatusEnum.ORDER_IN_PROGRESS, StatusEnum.ORDER_APPROVED, StatusEnum.ORDER_REJECTED]"
            [showERPStatus]="[OrderStatusERPEnum.ORDER_PENDING, OrderStatusERPEnum.ORDER_SEND, OrderStatusERPEnum.ORDER_RECEIVED, OrderStatusERPEnum.ORDER_CREATED, OrderStatusERPEnum.ORDER_ERROR, OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE, OrderStatusERPEnum.ORDER_ERROR_ERP]" 
            [showCustomerType]="['BPT9002', 'BPT9001', 'BPT0001']"
            (selectionFilterApply)="getList()">
          </app-status-filters>

        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
            (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>

          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Información">
            <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
          </button>

          <button mat-icon-button color="primary"
            matTooltip="{{!this.showInterval ? 'Activar tiempo automático' : 'Desactivar tiempo automático'}}"
            (click)="openInterval(this.showInterval = !this.showInterval)">
            <mat-icon>{{ this.showInterval ? 'timer' : 'timer_off'}}</mat-icon>
          </button>

          <button mat-icon-button color="primary" [matMenuTriggerFor]="filterMenu" matTooltip="Sincronizar"
            (click)="synchronizeOrders(null)" [disabled]="!isGlobalSynchronizeAvailable">
            <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
          </button>

          <mat-menu #filterMenu="matMenu">
            <button mat-menu-item [matMenuTriggerFor]="statusMenu">
              <span>Estados</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="statusERPMenu">
              <span>Estados ERP</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="customerMenu">
              <span>Cliente</span>
            </button>
          </mat-menu>

          <mat-menu #statusMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(65, 106, 218)"></mat-icon>
              <span>Activo</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:x-circle" style="color:rgb(141, 19, 19)"></mat-icon>
              <span>Anulado</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:play-circle" style="color:rgb(236, 199, 58)"></mat-icon>
              <span>En progreso</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:check-circle" style="color:rgb(9, 133, 50)"></mat-icon>
              <span>Aprobado</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:x-circle" style="color:rgb(255, 0, 0)"></mat-icon>
              <span>Rechazado</span>
            </button>
          </mat-menu>
          <mat-menu #statusERPMenu="matMenu">
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:clock" style="color:rgb(233, 124, 61)"></mat-icon>
              <span>Pendiente envío a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:exclamation-triangle" style="color:rgb(141, 19, 19)"></mat-icon>
              <span>Error enviando a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:exclamation-triangle" style="color:rgb(255, 0, 0)"></mat-icon>
              <span>Error en ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-arrow-up" style="color:rgb(65, 106, 218)"></mat-icon>
              <span>Enviado a ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-arrow-down" style="color:rgb(236, 199, 58)"></mat-icon>
              <span>Recibido por ERP</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:clock" style="color:rgb(148, 46, 139)"></mat-icon>
              <span>Mod. pendiente de replicar</span>
            </button>
            <button mat-menu-item>
              <mat-icon svgIcon="heroicons_solid:document-check" style="color:rgb(9, 133, 50)"></mat-icon>
              <span>Creado en ERP</span>
            </button>
          </mat-menu>
          <mat-menu #customerMenu="matMenu">
            <button mat-menu-item>
              <mat-icon style="color: #2e7d32;">person</mat-icon>
              <span>Cliente Eventual</span>
            </button>
            <button mat-menu-item>
              <mat-icon style="color: #1976d2;">person_outline</mat-icon>
              <span>Consumidor Final</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
              (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>
              <ng-container matColumnDef="det">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button class="h-7 min-h-7 min-w-10 px-2 leading-6" (click)="toggleDetails(element)"
                    style="margin-left: 10px;">
                    <mat-icon class="icon-size-5" [svgIcon]="selectedProduct?._id === element._id
                                        ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="check">
                <th mat-header-cell *matHeaderCellDef class=" text-left first-col">
                  <mat-checkbox color="primary" (change)="$event ? masterToggle() : null; onCheckboxChange($event)"
                    [checked]="selection.hasValue() && isAllSelected()" [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col">
                  <mat-checkbox color="primary" (click)="$event.stopPropagation(); onCheckboxChange($event, element)"
                    (change)="$event ? selection.toggle(element) : null;" [checked]="selection.isSelected(element)"
                    [aria-label]="checkboxLabel(element)" [disabled]="!(
                              validateDataToSynchronize(element)
                            )">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle"></th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <mat-icon *ngIf="element.statusId == StatusEnum.INACTIVE" svgIcon="heroicons_solid:x-circle" matTooltip="Anulado"
                    style="color:rgb(141, 19, 19); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="element.statusId == StatusEnum.ACTIVE" svgIcon="heroicons_solid:check-circle" matTooltip="Activo"
                    style="color:rgb(65, 106, 218); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_IN_PROGRESS" svgIcon="heroicons_solid:play-circle" matTooltip="En progreso"
                    style="color:rgb(236, 199, 58); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_APPROVED" svgIcon="heroicons_solid:check-circle" matTooltip="Aprobado"
                    style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="element.statusId == StatusEnum.ORDER_REJECTED" svgIcon="heroicons_solid:x-circle" matTooltip="Rechazado"
                    style="color:rgb(255, 0, 0); cursor: pointer;"></mat-icon>
                </td>
              </ng-container>
              <ng-container matColumnDef="statusERP">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle"></th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_PENDING || !(element.statusERP)" svgIcon="heroicons_solid:clock"
                    matTooltip="Pendiente envío a ERP" style="color:rgb(233, 124, 61); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_SEND" svgIcon="heroicons_solid:document-arrow-up"
                    matTooltip="Enviado a ERP" style="color:rgb(65, 106, 218); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_RECEIVED" svgIcon="heroicons_solid:document-arrow-down"
                    matTooltip="Recibido por ERP" style="color:rgb(236, 199, 58); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_CREATED" svgIcon="heroicons_solid:document-check"
                    matTooltip="Creado en ERP" style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_ERROR" svgIcon="heroicons_solid:exclamation-triangle"
                    matTooltip="Error enviando a ERP" style="color:rgb(141, 19, 19); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE" svgIcon="heroicons_solid:clock"
                    matTooltip="Mod. pendiente de replicar"
                    style="color:rgb(148, 46, 139); cursor: pointer;"></mat-icon>
                  <mat-icon *ngIf="element.statusERP == OrderStatusERPEnum.ORDER_ERROR_ERP" svgIcon="heroicons_solid:exclamation-triangle"
                    matTooltip="Error en ERP" style="color:rgb(255, 0, 0); cursor: pointer;"></mat-icon>
                </td>
              </ng-container>
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle"></th>
                <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                  <span *ngIf="element?.subApplication?.code == 'CSMOBILE-BACKOFFICE'"
                    style="background-color: rgb(40, 101, 141); color: white; padding: 3px 6px 3px 5px; border-radius: 5px; margin-left: 7px; margin-right: 7px; cursor: pointer;"
                    [matTooltip]="element?.subApplication?.name">
                    B
                  </span>
                  <span *ngIf="element?.subApplication?.code == 'CSMOBILE-APP'"
                    style="background-color: rgb(218, 41, 28); color: white; padding: 3px 6px 3px 5px; border-radius: 5px; margin-left: 7px; margin-right: 7px; cursor: pointer;"
                    [matTooltip]="element?.subApplication?.name">
                    A
                  </span>
                  <span *ngIf="element?.subApplication?.code == 'CSMOBILE-ERP'"
                    style="background-color: rgb(255, 123, 0); color: white; padding: 3px 6px 3px 5px; border-radius: 5px; margin-left: 7px; margin-right: 7px; cursor: pointer;"
                    [matTooltip]="'ERP'">
                    E
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="trip">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle">Viaje
                </th>
                <td mat-cell *matCellDef="let element" class="text-secondary text-left first-col table-text">
                  <div class="flex items-center px-3 cursor-pointer" [ngClass]="{ 'underline': hasTrip(element) }"
                    (click)="hasTrip(element) && goToTravel(element)"
                    [matTooltip]="hasTrip(element) ? 'Ir al viaje' : ''">
                    <span>{{ hasTrip(element) ? element.trip.id : '-' }}</span>
                    <mat-icon *ngIf="hasTrip(element)" class="ml-2 icon-size-3 hover:animate-bounce"
                      [svgIcon]="'heroicons_outline:rocket-launch'" style="color:rgb(0, 0, 0);"></mat-icon>
                  </div>
                </td>
              </ng-container>

                 <ng-container matColumnDef="info">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Ruta - Usuario</th>
                <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                  <app-user-route-display
                    [routeData]="{
                      routeName: element?.subRoute?.name ?? '-',
                      externalKeys: { code: element?.subRoute?.externalKeys?.code ??  '-' }
                    }"
                    [userData]="{username: element?.user?.user_login?.username ?? element?.user ?? '-' }"
                    [responsibleData]="{
                      name: element?.responsibleBusinessPartner?.name ?? '-',
                      personNumber: element?.responsibleBusinessPartner?.personNumber ?? '-',
                      externalKeys: { code: element?.responsibleBusinessPartner?.externalKeys?.code ?? '-' }
                    }"
                    [displayMode]="'detailed'"
                    [showRouteCode]="true"
                    [showUser]="true"
                    [showResponsible]="true">
                  </app-user-route-display>
                </td>
              </ng-container>

              <ng-container matColumnDef="subRoute">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Ruta
                </th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <p class="table-text-m" *ngIf="element.subRoute; else noData">
                    <span class="table-text-code">{{ element?.subRoute?.externalKeys?.code ?? element?.subRoute?.model
                      }}</span><br>
                    {{ element.subRoute?.name }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Usuario
                </th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <p class="table-text-m" *ngIf="element.user; else noData">
                    {{ element?.user?.user_login?.username }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="seller">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">
                  Responsable</th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <p class="table-text-m" style="min-width: 102px;">
                    <span class="table-text-code"
                      *ngIf="element.responsibleBusinessPartner?.personNumber || element.responsibleBusinessPartner?.externalKeys">
                      {{element.responsibleBusinessPartner?.personNumber ?
                      element.responsibleBusinessPartner?.personNumber + ' - ': '' }}
                      {{element.responsibleBusinessPartner?.externalKeys?.code}}<br></span>
                    {{ element.responsibleBusinessPartner?.name ?? '-' }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="businessPartner">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Pagador/Receptor
                </th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <app-business-partner-display
                    [soldTo]="element.soldTo"
                    [shipTo]="element.shipTo"
                    [customerType]="element.shipToType"
                    [showIcons]="true"
                    [compact]="true">
                  </app-business-partner-display>
                </td>
              </ng-container>
              <ng-container matColumnDef="documentNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"><span
                    style="text-align: left;">Nro. Doc.</span></th>
                <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                  <p class="table-text-m " style="min-width: 150px;">
                    <span [ngClass]="{ 'underline cursor-pointer': isThereOrderSourceTransaction(element) }"
                      (click)="isThereOrderSourceTransaction(element) && goToOrder(element)"
                      [matTooltip]="isThereOrderSourceTransaction(element) ? 'Ir al pedido asociado' : ''">
                      <span [ngClass]="{ 'text-secondary mr-2': isThereOrderSourceTransaction(element) }">{{
                        element?.serial ? element?.serial : '-' }}</span>
                      <mat-icon *ngIf="isThereOrderSourceTransaction(element)" class="icon-size-3 hover:animate-bounce"
                        [svgIcon]="'heroicons_outline:document-magnifying-glass'" style="color: #000;">
                      </mat-icon>
                    </span>
                    {{ element?.externalKeys?.code }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="class">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Clase
                </th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <p class="table-text-m">
                    @if(element.class){
                    <span class="table-text-code" *ngIf="getCode(element.class) as code">
                      {{ code }} <br>
                    </span>
                    }
                    {{ element?.class?.name }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Fecha
                </th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <p class="table-text-m" style="min-width: 130px;">
                    <b>C: </b>{{formatDate(element.loadDateTime)}}<br>
                    <b>E: </b>{{formatDate(element.deliveryDateTime)}}
                  </p>
                </td>
              </ng-container>

              <ng-container matColumnDef="subTotal">
                <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">
                  <span class="table-text-m-2">SubTotal {{ 'code' | companyCurrency: true }}</span>
                </th>
                <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                  <p class="table-text-m-2">
                    {{ (element?.subTotal | decimalFormat) }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="surcharge">
                <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">
                  <span class="table-text-m-2">Recargo {{ 'code' | companyCurrency: true }}</span>
                </th>
                <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                  <p class="table-text-m-2">
                    {{ (element?.totalSurcharges | decimalFormat) }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="discount">
                <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">
                  <span class="table-text-m-2">Descuento {{ 'code' | companyCurrency: true }}</span>
                </th>
                <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                  <p class="table-text-m-2">
                    {{ (element?.totalDiscounts | decimalFormat) }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="tax">
                <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">
                  <span class="table-text-m-2">Impuesto {{ 'code' | companyCurrency: true }}</span>
                </th>
                <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                  <p class="table-text-m-2">
                    {{ (element?.totalTaxes | decimalFormat) }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="total">
                <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">
                  <span class="table-text-m-2">Total {{ 'code' | companyCurrency: true }}</span>
                </th>
                <td mat-cell *matCellDef="let element" class="first-col table-text text-right">
                  <p class="table-text-m-2">
                    {{ (element?.total | decimalFormat) }}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="creation">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Creación
                </th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  {{formatDate(element?.creationDateTime, false)}}<br>{{formatHour(element?.creationDateTime)}}
                </td>
              </ng-container>
              <ng-container matColumnDef="loadDateTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Carga
                  y<br>Entrega</th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <b>C:</b> {{formatDate(element?.loadDateTime, false)}}<br>
                  <b>E:</b> {{formatDate(element?.deliveryDateTime, false)}}
                </td>
              </ng-container>
              <ng-container matColumnDef="documentStatus">
                <th mat-header-cell *matHeaderCellDef class="first-col table-tittle text-right">Estado<br>Doc.
                </th>
                <td mat-cell *matCellDef="let element" class="first-col text-right">
                  {{ '-' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class=" text-left first-col" style="min-width: 40px;">
                  <button *ngIf="selection.selected.length > 0 " mat-icon-button [matMenuTriggerFor]="actionOrder"
                    matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionOrder="matMenu">
                    <button mat-menu-item (click)="onUpdateOrder()">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Mover</span>
                    </button>
                  </mat-menu>
                </th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col">
                  <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #actionMenu="matMenu">
                    <button *ngIf="element?.statusId != StatusEnum.INACTIVE && element?.statusId != StatusEnum.ORDER_APPROVED && element?.statusId != StatusEnum.ORDER_REJECTED"
                      mat-menu-item (click)="onUpdateOrder(element)" [disabled]="!(
                                      validateDataToEdit(element)
                                    )">
                      <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                      <span>Mover</span>
                    </button>
                    <button mat-menu-item (click)="synchronizeOrders(element)" [disabled]="!(
                                    validateDataToSynchronize(element)
                                  )">
                      <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
                      <span>Sincronizar</span>
                    </button>
                    <!--<button mat-menu-item (click)="generateOrder(element)"
                                [disabled]="!(
                                  validateDataToGenerateOrder(element)
                                )">
                                <mat-icon svgIcon="heroicons_outline:arrow-right-circle"></mat-icon>
                                <span>Generar Cotización</span>
                              </button>
                              <button mat-menu-item (click)="cloneOrder(element, 'copy')"
                                [disabled]="!(
                                    validateDataToCopy(element)
                                  )">
                                <mat-icon svgIcon="heroicons_outline:document-duplicate"></mat-icon>
                                <span>Copiar</span>
                              </button>
                              <button mat-menu-item (click)="cloneOrder(element, 'divide')"
                                [disabled]="!(
                                    validateDataToDivide(element)
                                  )">
                                <mat-icon svgIcon="heroicons_outline:clipboard-document"></mat-icon>
                                <span>Dividir</span>
                              </button>-->
                    <button mat-menu-item (click)="openLogModal(element)">
                      <mat-icon>visibility</mat-icon>
                      <span>Visualizar logs</span>
                    </button>
                    <!--<button mat-menu-item (click)="openModal(element)" [disabled]="!(validateDataToAppOrRejected(element))">
                                <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
                                <span>{{projectName == 'DIUNSA' ? 'Rechazar' : 'Aprobar/Rechazar'}}</span>
                              </button>-->
                    <button mat-menu-item (click)="showPendingOrdersByUser(element, 'soldTo')">
                      <mat-icon svgIcon="hourglass_empty"></mat-icon>
                      <span>Pendientes Pagador</span>
                    </button>
                    <button mat-menu-item (click)="showPendingOrdersByUser(element, 'shipTo')">
                      <mat-icon svgIcon="hourglass_empty"></mat-icon>
                      <span>Pendientes Receptor</span>
                    </button>
                    <app-document-flow-button [element]="element"></app-document-flow-button>
                  </mat-menu>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                  <tr *ngIf="selectedOrder?._id === element._id" class="details-row">
                    <td [attr.colspan]="displayedColumns.length">
                      <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: row }"></ng-container>
                    </td>
                  </tr>
              </ng-container>

              <!-- Header Row -->
              <tr mat-header-row *matHeaderRowDef="displayedColumns"
                class="sticky top-0 z-10  bg-white dark:bg-gray-900">
              </tr>
              <!-- Fila principal -->
              <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="border-b"
                [class.table-expanded-row]="selectedOrder?._id === element._id"></tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
            </table>
          </div>
          <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos,
            no
            hay registros para mostrar.
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
            [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
        </div>
      </div>
    </div>
    <!-- Modales -->
  </div>
  <ng-template #rowDetailsTemplate let-order>
    <div class="overflow-hidden">
      <div class="flex border-b">
        <form class="flex w-full flex-col">
          <div class="flex flex-col p-3 sm:flex-row">
            <div class="flex flex-auto flex-wrap">
              <div class="grid-container table-text">
                <div class="row">
                  <div class="cell cell-3 table-title">Pagador:</div>
                  <div class="cell cell-4">
                    @if (selectedOrder.shipToType) {
                    <span [matTooltip]="selectedOrder.shipToType == 'BPT9001' ? 'Consumidor Final' : 'Cliente Eventual'"
                      style="cursor: pointer;">
                      <b>{{ selectedOrder.shipToType == 'BPT9001' ? '(C. Final)' : '(C. Eventual)' }}</b>
                    </span>
                    }
                    {{selectedOrder.soldTo?.externalKeys?.code + ' - '}} {{selectedOrder.soldTo?.name}}
                  </div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Destinatario:</div>
                  <div class="cell cell-4">
                    @if (selectedOrder.shipToType) {
                    <span [matTooltip]="selectedOrder.shipToType == 'BPT9001' ? 'Consumidor Final' : 'Cliente Eventual'"
                      style="cursor: pointer;">
                      <b>{{ selectedOrder.shipToType == 'BPT9001' ? '(C. Final)' : '(C. Eventual)' }}</b>
                    </span>
                    }
                    {{selectedOrder.shipTo?.externalKeys?.code + ' - '}} {{selectedOrder.shipTo?.name}}
                  </div>
                </div>
                @if (selectedOrder.shipToLegalCode) {
                <div class="row">
                  <div class="cell cell-3 table-title">RTN:</div>
                  <div class="cell cell-4">{{ selectedOrder.shipToLegalCode }}</div>
                </div>
                }
                <div class="row">
                  <div class="cell cell-3 table-title">Dirección:</div>
                  <div class="cell cell-4">{{selectedOrder.address?.address }} {{ selectedOrder.address?.postalCode ? '
                    / ' + selectedOrder.address?.postalCode : ' ' }} {{ selectedOrder.address?.contactName ? ' / ' +
                    selectedOrder.address?.contactName : ' ' }} {{ selectedOrder.address?.locationTwo?.name ? ' / ' +
                    selectedOrder.address?.locationTwo?.name : ' ' }} {{ selectedOrder.address?.LocationThree?.name ? '
                    / ' + selectedOrder.address?.LocationThree?.name : ' ' }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Clase de Expedición:</div>
                  <div class="cell cell-4">{{ selectedOrder?.expeditionCondition?.externalKeys?.code }} - {{
                    selectedOrder?.expeditionCondition?.name}}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Condición de Pago:</div>
                  <div class="cell cell-4">{{ selectedOrder?.paymentCondition?.externalKeys?.code }} - {{
                    selectedOrder?.paymentCondition?.name}}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Observaciones:</div>
                  <div class="cell cell-4">{{selectedOrder?.note ?? ' - '}}</div>
                </div>
                <div class="row">

                </div>
              </div>
              <div class="grid-container table-text">
                <div class="row">
                  <div class="cell cell-3 table-title">Estado Global:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'GLOBAL') }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Estado de rechazo:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'REJECT') }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Estado de entrega:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'DELIVERY') }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Estado de crédito:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'CREDIT') }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Estado de factura:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'INVOICE') }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Estado de usuario:</div>
                  <div class="cell cell-4">{{ getExtraStatusName(selectedOrder?.extraStatusERP, 'USER') }}</div>
                </div>
              </div>
              <div class="grid-container table-text">
                <div class="row">
                  <div class="cell cell-3 table-title">SubTotal:</div>
                  <div class="cell cell-4 text-right">{{ (selectedOrder?.subTotal | decimalFormat) }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Recargo:</div>
                  <div class="cell cell-4 text-right">{{ (selectedOrder?.totalSurcharges | decimalFormat) }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Descuento:</div>
                  <div class="cell cell-4 text-right">{{ (selectedOrder?.totalDiscounts | decimalFormat) }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Impuesto:</div>
                  <div class="cell cell-4 text-right">{{ (selectedOrder?.totalTaxes | decimalFormat) }}</div>
                </div>
                <div class="row">
                  <div class="cell cell-3 table-title">Total:</div>
                  <div class="cell cell-4 text-right">{{ (selectedOrder?.total | decimalFormat) }}</div>
                </div>
              </div>
              <div class="flex w-full flex-col">
                <table class="min-w-500 overflow-y-visible mat-elevation-z mt-3" mat-table
                  [dataSource]="dataSourceDetail" matSort>
                  <ng-container matColumnDef="material">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      <span style="margin-left: 5px;">Material</span>
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                      <p class="table-text-m">
                        <span class="table-text-code" *ngIf="getCode(detail.material) as code"
                          [style.textDecoration]="detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'"
                          [style.textDecorationColor]="detail.statusId == StatusEnum.INACTIVE  ? 'red' : 'inherit'">
                          {{ code }}
                        </span>
                        <span *ngIf="detail.statusId == StatusEnum.INACTIVE" style="color: red;"><b> (Eliminado)</b></span><br>
                        <span [style.textDecoration]="detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'"
                          [style.textDecorationColor]="detail.statusId == StatusEnum.INACTIVE  ? 'red' : 'inherit'">
                          {{ detail.material?.name }}
                        </span>
                      </p>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="note">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      Nota</th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                      <button mat-icon-button color="primary" matTooltip="{{detail.note}}"
                        [disabled]="!(detail.note && detail.note!='')">
                        <mat-icon svgIcon="heroicons_outline:chat-bubble-bottom-center-text"></mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="warehouse">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col table-tittle">
                      Almacén</th>
                    <td mat-cell *matCellDef="let detail" class="px-6 text-left first-col table-text">
                      <p *ngIf="!detail.isEditMode" class="table-text-m">
                        <span class="table-text-code" *ngIf="getCode(detail.warehouse) as code"> {{code}} <br> </span>
                        {{ detail.warehouse?.name }}
                      </p>
                      <mat-form-field *ngIf="detail.isEditMode" class="mt-2 w-full" appearance="fill"
                        floatLabel="never">
                        <mat-select [(ngModel)]="detail.warehouse" placeholder="Almacén"
                          matTooltip="{{detail.warehouse?.name}}" [ngModelOptions]="{standalone: true}"
                          [compareWith]="compareById" (selectionChange)="detail.thereIsChanges = true; 
                                          onChangeWarehouseInOrderDetail(detail)">
                          @for (warehouse of selectedOrder.warehousesToUpdate || []; track warehouse) {
                          <mat-option [value]="warehouse" class="text-content">
                            {{warehouse.externalKeys?.code + ' - '}}{{ warehouse.name }}
                          </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="soldQuantity">
                    <th mat-header-cell *matHeaderCellDef class="px-6 first-col table-tittle text-left">Cantidad (U.M)
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-left">
                      <app-unit-measure-display
                        *ngIf="!detail.isEditMode"
                        [usedUnit]="{
                          quantity: detail?.soldQuantity,
                          unitId: detail?.soldUnitOfMeasure?._id,
                          unitName: detail?.soldUnitOfMeasure?.name,
                          unitAbbreviation: detail?.soldUnitOfMeasure?.code
                        }"
                        [baseUnit]="{
                          quantity: detail?.baseQuantity,
                          unitId: detail?.baseUnitOfMeasure?._id,
                          unitName: detail?.baseUnitOfMeasure?.name,
                          unitAbbreviation: detail?.baseUnitOfMeasure?.code
                        }"
                        [parallelUnit]="{
                          quantity: detail?.pararellQuantity,
                          unitId: detail?.pararellUnitOfMeasure?._id,
                          unitName: detail?.pararellUnitOfMeasure?.name,
                          unitAbbreviation: detail?.pararellUnitOfMeasure?.code
                        }"
                        [material]="{
                          _id: detail?.material?._id,
                          code: detail?.material?.code,
                          UMPActive: detail?.material?.UMPActive
                        }"
                        [companyUMPActive]="UMPActive"
                        [statusId]="detail.statusId"
                      ></app-unit-measure-display>
                      <mat-form-field *ngIf="detail.isEditMode" class="mt-2" appearance="fill" floatLabel="never"
                        style="margin-bottom: -1.2em;">
                        <input matInput type="number" [(ngModel)]="detail.soldQuantity" placeholder="Cantidad"
                          [ngModelOptions]="{standalone: true}" aria-label="Cantidad" matInput
                          (change)="onChangeQuantityInOrderDetail(selectedOrder, detail)"
                          (keyup)="onChangeQuantityInOrderDetail(selectedOrder, detail)">
                        <span matSuffix>{{detail.soldUnitOfMeasure?.code}}</span>
                      </mat-form-field>
                      <br><span *ngIf="detail.stockToValidate !== undefined" style="font-size: 0.9em;">
                        <b [style.color]="detail.stockToValidate >= detail.soldQuantity ? 'green' : 'inherit'">
                          Disponible:
                        </b> {{detail.stockToValidate}}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="unitPrice">
                    <th mat-header-cell *matHeaderCellDef class="px-6 first-col table-tittle text-center">Precio  {{ 'code' | companyCurrency: true }}</th>
                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-center">
                      @if (detail.isEditMode && selectedOrder.class.canUpdatePrices == true) {
                      <mat-form-field class="mt-2" appearance="fill" floatLabel="never">
                        <input matInput type="number" [(ngModel)]="detail.unitPrice" placeholder="Precio"
                          [ngModelOptions]="{standalone: true}" aria-label="Precio" matInput
                          (change)="onChangePriceInOrderDetail(selectedOrder, detail)"
                          (keyup)="onChangePriceInOrderDetail(selectedOrder, detail)">
                      </mat-form-field>
                      } @else {
                      <span [style.textDecoration]="detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'"
                        [style.textDecorationColor]="detail.statusId == StatusEnum.INACTIVE  ? 'red' : 'inherit'">
                        {{ (detail?.unitPrice | decimalFormat)}}
                      </span>
                      }
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="subTotal">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                      class="px-6 text-left first-col table-tittle">SubTotal  {{ 'code' | companyCurrency: true }}</th>
                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
                      <span [style.textDecoration]="detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'"
                        [style.textDecorationColor]="detail.statusId == StatusEnum.INACTIVE  ? 'red' : 'inherit'">
                        {{ (detail?.subTotal | decimalFormat) }}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="totalSurcharges">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                      class="px-6 text-left first-col table-tittle">Recargo  {{ 'code' | companyCurrency: true }}</th>
                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
                      <span [style.textDecoration]="detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'"
                        [style.textDecorationColor]="detail.statusId == StatusEnum.INACTIVE  ? 'red' : 'inherit'">
                        {{ (detail?.totalSurcharges | decimalFormat) }}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="totalDiscounts">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                      class="px-6 text-left first-col table-tittle">Descuento  {{ 'code' | companyCurrency: true }}</th>
                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
                      <span [style.textDecoration]="detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'"
                        [style.textDecorationColor]="detail.statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'">
                        {{ (detail?.totalDiscounts | decimalFormat) }}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="tax">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                      class="px-6 text-left first-col table-tittle">Impuesto  {{ 'code' | companyCurrency: true }}</th>
                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
                      <span [style.textDecoration]="detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'"
                        [style.textDecorationColor]="detail.statusId == StatusEnum.INACTIVE  ? 'red' : 'inherit'">
                        {{ (detail?.totalTaxes | decimalFormat) }}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before"
                      class="px-6 text-left first-col table-tittle">Total  {{ 'code' | companyCurrency: true }}</th>
                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-right">
                      <span [style.textDecoration]="detail.statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'"
                        [style.textDecorationColor]="detail.statusId == StatusEnum.INACTIVE  ? 'red' : 'inherit'">
                        {{ (detail?.total | decimalFormat) }}
                      </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="px-6 first-col table-tittle text-center">
                      <button *ngIf="validateDataToEdit(selectedOrder)" mat-icon-button color="primary"
                        (click)="onAddOrderDetail(selectedOrder)" matTooltip="Agregar detalle">
                        <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
                      </button>
                    </th>
                    <td mat-cell *matCellDef="let detail" class="px-6 first-col table-text text-center">
                      <div *ngIf="detail.statusId != StatusEnum.INACTIVE && validateDataToEdit(selectedOrder)">
                        <button *ngIf="!detail.isEditMode" color="primary" mat-icon-button
                          (click)="detail.isEditMode = true" matTooltip="Editar">
                          <mat-icon svgIcon="heroicons_outline:pencil"></mat-icon>
                        </button>
                        <button *ngIf="detail.isEditMode" color="primary" mat-icon-button
                          (click)="openOrderDetailUpdateConfirmation(selectedOrder, detail)" matTooltip="Guardar">
                          <mat-icon svgIcon="heroicons_outline:check"></mat-icon>
                        </button>
                        <button color="warn" mat-icon-button (click)="onCancelOrder(selectedOrder, detail)"
                          matTooltip="Eliminar">
                          <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                        </button>
                      </div>
                      <div *ngIf="detail.statusId == StatusEnum.INACTIVE">
                        <button mat-icon-button color="warn" matTooltip="{{detail.reasonForRejection}}"
                          [disabled]="!(detail.reasonForRejection && detail.reasonForRejection != '')">
                          <mat-icon svgIcon="heroicons_outline:chat-bubble-bottom-center-text"></mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Header Row -->
                  <tr mat-header-row *matHeaderRowDef="displayedColumnsDetail" class="bg-gray-100 dark:bg-gray-900">
                  </tr>
                  <!-- Fila principal -->
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsDetail;" class="border-b"></tr>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>

  <ng-template #noData>
    <span>
      -
    </span>
  </ng-template>

  <app-filter (onFilterEvent)="getList()" (onCleanEvent)="clearFilters()">
    <app-filter-section title="Rango de fechas" [expanded]="true">
      <app-dates-filters [form]="form" [showDateCreationRange]="true" [showStartTrip]="true"
        [showEndTrip]="true" [showUploadDateRange]="true" [showDeliveryDate]="true"></app-dates-filters>
    </app-filter-section>

    <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
      <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true"
        [warehouse]="true" [loadData]="loadConfigData"></app-configuration-filters>
    </app-filter-section>

    <app-filter-section title="Documentos" [expanded]="false" (onExpanded)="onDocumentsExpanded()">
      <app-documents-filters [form]="form" [documentClass]="true"
      [typeDocumentClass]="DocumentTypeEnum.DOCUMENTO_DE_CARGA" [loadData]="loadDocumentsData"
      ></app-documents-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
      <app-routes-filters [form]="form" [route]="true" [loadData]="loadRoutesData"></app-routes-filters>
    </app-filter-section>

    <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
      <app-business-partners-filters [form]="form" [assignedUser]="true" [payingBusinessPartner]="true"
        [receivingBusinessPartner]="true" [loadData]="loadBusinessPartnersData"></app-business-partners-filters>
    </app-filter-section>

    <app-filter-section title="Gestión de Materiales" [expanded]="false" (onExpanded)="onMaterialsExpanded()">
      <app-materials-management-filters [form]="form" [materialGroup]="true" [material]="true" [isMultiple]="true"
      [loadData]="loadMaterialsData">
      </app-materials-management-filters>
    </app-filter-section>
  </app-filter>
</mat-sidenav-container>

<!-- Modal para confirmar actualización de un detalle -->
<ng-template #orderDetailUpdateConfirmationDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-yellow-500 ml-4 mt-6"
        style="font-size: 32px"></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Confirmar actualización
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>¿Está seguro que desea actualizar el detalle?</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-between">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #pendingOrderByUserModal>
  <h2 mat-dialog-title class="text-lg font-bold mb-1">Pedidos pendientes - {{pendingUserName}}</h2>
  <small></small>
  <mat-dialog-content class="modal-content">
    <app-order-table [ordersData]="pendingOrders" (onSortChange)="changeSort($event)"
      [displayedColumns]="(['det', 'select', 'serial','trip', 'subRoute', 'soldTo', 'shipTo', 'address', 'deliveryDateTime', 'weight', 'actions'])"
      [loadCalculationMode]="loadCalculationMode" [UMPActive]="UMPActive" [canJoin]="false"
      [pendingModalOpen]="pendingModalOpen" [pendingUserName]="pendingUserName">
    </app-order-table>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>